module.exports = __webpack_public_path__ + "img/gray-cross.c46c98d0.svg";